import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy redirect that preserves the query string (App.jsx
// LegacyBehaviourRedirect kept location.search). Lives on the index route so
// it only matches /behavior exactly and never intercepts /behavior/banners.
export const Route = createFileRoute("/_shell/behavior/")({
  beforeLoad: () => {
    throw redirect({
      to: "/behaviour-studio",
      search: (current) => current,
      replace: true,
    });
  },
});
